import { InjectionToken } from '@angular/core';

export const AUTH_USE_AUTH0 = new InjectionToken<boolean>('AUTH_USE_AUTH0');
